__webpack_require__.p = "/views-board/system-email-templates/";